import styles from "./GalleryFrontPage.module.css";
import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import arrow_icon from "../../../assets/images/icons/arrow_icon.png";
import gallery_icon from "../../../assets/images/icons/gallery_ace.svg";
const GalleryFrontPage = () => {
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <div className={styles.main_div}>
        <div className={styles.gallery_header}>
          <img
            className={styles.upload_image_gallery_icon}
            src={gallery_icon}
            alt="top_gallery"
          />
          <div className={styles.gallery_header_text}>Gallery</div>
        </div>
        <div className={styles.card_section_main}>
          <div
            onClick={() => {
              navigate("/gallery-view");
            }}
            className={styles.card_single_main}
          >
            <div className={styles.card_single_circle_main}>保管期間 3カ月</div>
            <div className={styles.card_text_main}>
              <div className={styles.card_single_arrow1}>
                <img
                  className={styles.upload_arrow_icon}
                  src={arrow_icon}
                  alt="arow icon"
                />
              </div>
              <div className={styles.card_single_top}>
                <div>ギャラリーを見る</div>
              </div>
              <div className={styles.card_middle_hr}></div>
              <div className={styles.card_single_bottom1}>
                <div className={styles.card_bottom_div1}>
                  期限内にダウンロードしてください
                </div>
              </div>
            </div>
          </div>
          <div
            onClick={() => navigate("/gallery-annual-storage")}
            className={styles.card_single_main}
          >
            <div className={styles.card_text_main}>
              <div className={styles.card_single_arrow}>
                <img
                  className={styles.upload_arrow_icon}
                  src={arrow_icon}
                  alt="arow icon"
                />
              </div>
              <div className={styles.card_single_top}>
                <div>年間保管パス</div>
              </div>
              <div className={styles.card_middle_hr}></div>
              <div className={styles.card_single_bottom}>
                <div className={styles.card_bottom_div1}>
                  大切なデータをずっと
                </div>
                <div className={styles.card_bottom_div1}>
                  保管したい場合はこちら
                </div>
              </div>
            </div>
          </div>
          <div
            className={styles.card_single_main}
            onClick={() => navigate("/gallery-data-repuchase")}
          >
            <div className={styles.card_text_main}>
              <div className={styles.card_single_arrow}>
                <img
                  className={styles.upload_arrow_icon}
                  src={arrow_icon}
                  alt="arow icon"
                />
              </div>
              <div className={styles.card_single_top}>
                <div>データ再購入</div>
              </div>
              <div className={styles.card_middle_hr}></div>

              <div className={styles.card_single_bottom}>
                <div className={styles.card_bottom_div1}>期限切れデータを</div>
                <div className={styles.card_bottom_div1}>
                  購入される場合はこちら
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.mid_hr}></div>
        <div className={styles.text_section01}>
          <div className={styles.text_section_header}>
            撮影データの無料保管期限について
          </div>
          <div className={styles.text_section_text_summary}>
            アップロードから3カ月です。期限を過ぎると自動的に消去されますので、PCやUSBなどご自身でダウンロードをお願いいたします。ギャラリーに掲載しているお写真は、サイズが大きなデータ写真です。スマートフォンの容量が足りない場合は保存できない場合がございますので空き容量をご確認くださいませ。また、大切なデータをずっと保管できる
            <span
              className={styles.bottom_blue_span}
              onClick={() => navigate("/gallery-annual-storage")}
            >
              ▶︎年間保管パス
            </span>
            をぜひご利用ください。
          </div>
        </div>
        <div className={styles.spacing02}></div>
        <div className={styles.text_section01}>
          <div className={styles.text_section_header}>
            期限切れのお写真で、アイテムグッズを編集したい場合
          </div>
          <div className={styles.text_section_text_summary}>
            データを購入いただくか、ご自身で保存した写真をギャラリーにアップロードしてください。なお、過去にAcestudioで撮影したお写真のみアップロードが可能です。撮影したお写真以外でのグッズ制作はできませんのでご了承ください。
          </div>
          <div
            onClick={() => {
              navigate("/album/create");
            }}
            className={styles.bottom_blue}
          >
            ▶︎ご自身のデータをアップロードする
          </div>
        </div>
        <div className={styles.spacing03}></div>
      </div>
      <Footer />
    </>
  );
};
export default GalleryFrontPage;
